export default {
  namespaced: true,
  state: () => ({
    adminUrlSettings: {
      useCustomUrl: "false",
      customUrlPrefix: "",
    },
  }),
  getters: {
    storeAdminUrlSettings: (state) => state.adminUrlSettings,
  },
  mutations: {
    setAdminUrlSettings(state, { key, value }) {
      state.adminUrlSettings[key] = value;
    },
  },
};
